import { createFileRoute } from "@tanstack/react-router";
import { LegalDocs } from "@/components/LegalDocs";

function RouteComponent() {
  return <LegalDocs />;
}

export const Route = createFileRoute("/_authenticated/legal-documents/")({
  component: RouteComponent,
  staticData: { page: "operations" },
});
